var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapcut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 197,
    rx: 20,
    fill: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5051 33.8369C88.038 32.8666 109.147 34.3918 129.742 33.736C152.975 34.6974 165.704 47.0439 165.793 70.6775C165.206 90.347 166.529 110.426 165.793 130.048C164.876 154.581 153.821 166.251 129.131 167.268C109.369 166.708 89.1923 168.025 69.4783 167.286C45.4826 166.387 33.2548 155.661 32.243 131.232C32.9077 110.901 31.4003 90.0562 32.243 69.7874C33.1984 46.7887 44.3669 34.9318 67.5051 33.8369Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.605 134.486C145.584 134.572 145.174 135.05 144.999 134.803L128.843 126.323C128.789 131.851 125.285 135.248 119.903 135.785C102.189 134.925 83.1927 137.052 65.627 135.833C61.1702 135.524 56.7847 133.7 56.0726 128.771C55.8441 127.187 55.7225 113.362 56.1409 112.674L79.1395 100.221L57.58 89.2866L56.1468 88.346C55.7522 87.6903 55.8412 74.7474 55.9866 73.0561C56.3248 69.1513 59.2386 66.2316 63.0455 65.5758L121.398 65.5254C126.08 66.374 128.742 70.0563 128.843 74.7029L144.999 66.2227C145.183 65.9645 145.605 66.5046 145.605 66.5402V79.5958L106.731 100.369L145.605 121.136V134.489V134.486Z",
    fill: "#010101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.977 122.469H64.6006L65.4848 121.721L92.9105 107.63C100.72 111.564 108.503 115.567 116.236 119.644C117.79 120.463 119.615 121.383 120.977 122.469Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.977 78.5547L118.906 79.8959L92.9372 93.3669C85.8367 89.8211 78.7541 86.2279 71.7159 82.5634C69.7427 81.5367 67.3363 80.4062 65.4848 79.2995C65.1614 79.1066 64.6688 78.9998 64.6006 78.5518H120.977V78.5547Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapcut);
export default __webpack_public_path__ + "static/media/capcut.4e32a10619412157120c6a3ba001fb8d.svg";
export { ForwardRef as ReactComponent };